import { Box, HStack, VStack } from "@chakra-ui/react";

const DetailRow = ({ name, description, value, ...rest }) => {
  if(!value) return (<></>)

  return (
    <HStack spacing={4} fontSize='sm' width={'100%'} whiteSpace={'pre-wrap'} {...rest} alignItems={"flex-start"} justifyContent={"space-between"} >
      <VStack spacing={0} alignItems={'flex-start'}><Box fontWeight={'medium'}>{name}</Box>
        {description && <Box color='gray.500'>{description}</Box>}</VStack>
      <Box textAlign="right" alignSelf='center' color={"gray.500"}>{value}</Box>
    </HStack>
  )
}

export default DetailRow;
